import React, { useState } from 'react';
import { message, Form, Input, Layout, Typography } from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { get } from 'lodash';

import PdButton from 'components/pd-button';

import AdminApi from 'services/admin';

const { Content } = Layout;
const { Title } = Typography;

export function AdminChangePassword() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loadingButton, setLoadingButton] = useState(false);

  async function handleSubmit(values) {
    try {
      setLoadingButton(true);
      await AdminApi.changeAdminPassword(values);

      navigate({
        pathname: '/profile',
      });

      message.success('Successfully changed password');
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      setLoadingButton(false);
    }
  }

  return (
    <Layout className="pd-cms-admin main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">
            <Title>
              <Link to="/profile">
                <CaretLeftOutlined />
              </Link>
              Change Password
            </Title>
          </div>
          <Content className="pageContent">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSubmit}
              className="pd-admin-create-form">
              <Form.Item
                label="Old Password"
                name="old_password"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Old Password!',
                  },
                ]}>
                <Input type="password" placeholder="Old Password" />
              </Form.Item>

              <Form.Item
                label="New Password"
                name="password"
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}>
                <Input type="password" placeholder="New Password" />
              </Form.Item>

              <Form.Item
                label="New Password Confirmation"
                name="password_confirmation"
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}>
                <Input
                  type="password"
                  placeholder="New Password Confirmation"
                />
              </Form.Item>

              <Form.Item>
                <PdButton
                  type="primary"
                  full
                  htmlType="submit"
                  loading={loadingButton}>
                  Change Password
                </PdButton>
              </Form.Item>
            </Form>
          </Content>
        </div>
      </div>
    </Layout>
  );
}
